import {Component, EventEmitter, Output, Input} from '@angular/core';
import {FormGroup} from '@angular/forms';
import { ActivatedRoute } from '@angular/router';

import {UserService} from '../../../api/user.service';
import {NotificationServiceBus} from '../../../notification/notification.service';
import {GLOBAL} from '../../../shared/global';
import {SpinnerService} from '../../../spinner/spinner.service';
@Component({
  selector: 'app-user-password-form',
  templateUrl: './user-password-form.component.html',
  styleUrls: ['./user-password-form.component.css'],
})
export class UserPasswordFormComponent {

  @Input() resetPasswordMsg = false;

  @Output() success = new EventEmitter();

  curr_password = '';
  new_password = '';
  confirm_password = '';
  hasTemporaryPassword = this.route.snapshot.queryParamMap.has('temporary');
  constructor(
    public userDataService: UserService,
    public notificationServiceBus: NotificationServiceBus,
    public spinnerService: SpinnerService,
    public route: ActivatedRoute
  ) {}

  editUser(form: FormGroup) {
    if (form.invalid) {
      this.notificationServiceBus.launchNotification(true, GLOBAL.MISSING_FIELDS_ERROR_MESSAGE);
      return;
    }

    this.spinnerService.requestInProcess(true);

    this.userDataService.updatePassword(GLOBAL.currentUser.id, this.curr_password, this.new_password).subscribe(
      (res: any) => {
        if (res.status === 200) {
          // UI Notification
          this.spinnerService.requestInProcess(false);

          this.notificationServiceBus.launchNotification(false, 'User password updated Successfully');

          this.success.next();
        }
      },
      (errors) => {
        this.spinnerService.requestInProcess(false);
        let e = errors.json();
        this.notificationServiceBus.launchNotification(true, e);
      }
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/user-management/user-password/user-password-form/user-password-form.component.ts